import env from '../../../envVariables';

export const generateGetEfficienceVersionResponse = requestId => ({
  '@RelatesTo': requestId,
  '@status': 'urn:oasis:names:tc:ebxml-regrep:ResponseStatusType:Success',
  version: env.REACT_APP_VERSION,
});
